import { Directive } from '@angular/core';

@Directive({
  selector: 'xpo-popover-title',
  host: { class: 'xpo-Popover-title' },
})
export class XpoPopoverTitle {}
